<template>
    <v-app  id="app">
        
        <div class="mt-7 font-weight-black text-lg-h6">
            {{tutorName}} 
        </div>
        <v-layout row>

            <v-flex lg12 xs12 class="mt-lg-10">

                <v-row justify-lg="end" justify-sm="start" class="ml-lg-12 ml-1 mt-lg-0 mt-2">

                    <v-col cols="1" lg="6" xs="12">

                        <v-row style="width:300px !important;">
                             <v-col lg="10" xs="12">   <v-autocomplete
                                v-model="month"
                                :items="months"
                                item-text="month"
                                item-value="no"
                                dense
                                class="ml-lg-0"
                                prepend-icon="mdi-calendar"
                                label="SELECT MONTH"
                                @change="getNoOfWeeks()"
                            
                            ></v-autocomplete>  </v-col>

                        </v-row>

                    </v-col>

                </v-row>

                <v-data-table :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" dense :headers="headers" hide-default-footer :items="tables" item-key="name" class="elevation-0 table-rating">
                 
                             <template slot="item" slot-scope="props">

                                        <tr @click="weekForm(props.item)">
                                            <td class="text-center"> {{props.item.weekno}} </td>
                                            <td class="text-center"> {{props.item.status}} </td>
                                            <td class="text-center"> {{props.item.score+"/15"}} </td>
                                            

                                        </tr>

                                    </template>


                </v-data-table> 
                <div>
                    <v-layout>
                        <v-flex lg9 class="ml-lg-16">

                            <div class="averageScoreLabel  text-center mt-8"> AVERAGE SCORE </div>

                        </v-flex>
                        <v-flex lg3>

                            <div class=" mt-5 text-lg-h4 ml-lg-3 averageScore"> {{totalWeekScore==0 ? 0 : Math.round((parseFloat(averageScore) / parseFloat(totalWeekScore))*100)/100}} </div>
                           
                        </v-flex>

                    </v-layout>
                </div>

            </v-flex>

        </v-layout>

    </v-app>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
Vue.use(axios)
export default {
    name:'weeklyreport',
    props:['wkReport',"moNum","weekScore"],
    data: () => ({
        month:'',
        months: [{'no':'01','month':'January'}, {'no':'02','month':'February'}, {'no':'03','month':'March'}, {'no':'04','month':'April'}, {'no':'05','month':'May'}, {'no':'06','month':'June'}, {'no':'07','month':'July'}, {'no':'08','month':'August'}, {'no':'09','month':'September'}, {'no':'10','month':'October'}, {'no':'11','month':'November'}, {'no':'12','month':'December'},],
        tables:[],
        weekno:'',
        monthno:'',
        yearno:'',
        Status:'',
        averageScore:0,
        counter:0,
        tutorName:'',
        wkTotalScore:'',
        totalWeekScore:0,
    }),
    computed: {
       headers(){ return  [{

          
          text: 'Week No.',
          align: 'center',
          sortable: false,
          value: 'weekno',
          class: "grey lighten-2"
        },
        { text: 'Status',align: 'center', value: 'status' , class: "grey lighten-2", sortable: false,},
        { text: 'Score',align: 'center', value: 'score',class: "grey lighten-2", sortable: false,},
        
        ]}
    },
    watch(){
    },
    mounted() {
        
        this.month = this.moNum
        this.getResultWeekly()

        axios.get('https://phone.megatalking.com/origin/api/monitoring.php?action=getTutors')
        //.then(response=>console.warn(response.data))
        .then(response=>{
        
          let tutorlist = response.data
        
              for(let i = 0 ; i<=tutorlist.length ; i++){
                    


                    if(this.$route.params.t_id.toString().toLowerCase().indexOf(tutorlist[i].tutor_id.toLowerCase()) !== -1){
                        this.tutorName = tutorlist[i].tutor_full_name
                    }

               }
               
        })
        this.wkReport.$on('updateWeeks', this.updateWeeks)
        this.getNoOfWeeks()
        
    },  
   methods:{

        getNoOfWeeks(){
            this.averageScore = 0 
            this.totalWeekScore = 0
            this.tables=[]
            let today = new Date()
            let year = today.getFullYear()
            
             var day, date;

            day = 1;
            
            date = new Date(year, (this.month -1), day);
           
            this.counter = (date.getDay() >= 2) && (date.getDay() <= 5) ? 1 : 0
  
            while (date.getMonth() === (this.month-1)) {
                if (date.getDay() === 1) { // Sun=0, Mon=1, Tue=2, etc.
                    this.counter += 1;
                    
                }
                day += 1;
                date = new Date(2021,  (this.month -1), day);
               
            }
            
            for(let i =1 ; i<=this.counter ; i++){

                this.getResultWeekly(this.month,i,this.$route.params.t_id)
               
            }
           

            
           
        },

        getResultWeekly(month,week,t_id){

            axios.get('http://localhost/megatalking/performance/tutorperf.php?actionTaken=getData&week='+week+'&month='+month+'&t_id='+t_id+'')
                //.then(response=>console.warn(response.data))
                .then(response=>{
                    
                    let AllData = response.data
                    this.wkTotalScore =-1
                    let today = new Date()
                    let year = today.getFullYear()


                    if(AllData!="No data"){

                         

                        this.wkTotalScore = parseFloat(AllData.criteria['one']) +  parseFloat(AllData.criteria['two']) + parseFloat(AllData.criteria['three']) + parseFloat(AllData.criteria['four']) + parseFloat(AllData.criteria['five']) + parseFloat(AllData.criteria['six']) + parseFloat(AllData.criteria['seven']) + parseFloat(AllData.criteria['eight']) + parseFloat(AllData.criteria['nine']) + parseFloat(AllData.criteria['ten']);
                        
                         this.tables.push({

                            weekno: 'Week '+week,
                            status:  'Done',
                            score:  this.wkTotalScore,
                            criteria:{
                                onecri : AllData.criteria['one'],
                                twocri : AllData.criteria['two'],
                                threecri : AllData.criteria['three'],
                                fourcri : AllData.criteria['four'],
                                fivecri : AllData.criteria['five'],
                                sixcri : AllData.criteria['six'],
                                sevencri : AllData.criteria['seven'],
                                eightcri : AllData.criteria['eight'],
                                ninecri : AllData.criteria['nine'],
                                tencri : AllData.criteria['ten'],
                            },
                            date: AllData.date,
                            time: AllData.time,
                            teams:AllData.teams,
                            link:AllData.linked,
                            no: week,
                            month: this.month,
                            year: year,



                        })
                        this.averageScore+=this.wkTotalScore
                        this.totalWeekScore+=1

                    } else {

                        this.tables.push({

                            weekno: 'Week '+week,
                            status:   'Pending',
                            score:   0,
                            criteria:{
                                onecri : '',
                                twocri : '',
                                threecri : '',
                                fourcri : '',
                                fivecri : '',
                                sixcri : '',
                                sevencri : '',
                                eightcri : '',
                                ninecri : '',
                                tencri : '',
                            },
                            date: '',
                            time:'',
                            teams:'',
                            link:'',
                            no: week,
                            month: this.month,
                            year: year

                        })

                    }
                   

            }).catch(error=>console.log('this is the error '+error))

        },

        updateWeeks(){

             this.averageScore = 0 
             this.totalWeekScore = 0
             let updateData = Vue.prototype.$submitData
            
             let objIndex = this.tables.findIndex((obj => obj.no == this.weekno));

             if(this.tables[objIndex].month ==  this.month){

                 this.tables[objIndex].status = 'Done'
                 this.tables[objIndex].score = Vue.prototype.$scores
                 this.tables[objIndex].date = updateData.date
                 this.tables[objIndex].time = updateData.time
                 this.tables[objIndex].teams = updateData.teams
                 this.tables[objIndex].link = updateData.linked
                 this.tables[objIndex].criteria['onecri'] = updateData.criteria['one']
                 this.tables[objIndex].criteria['twocri'] = updateData.criteria['two']
                 this.tables[objIndex].criteria['threecri'] = updateData.criteria['three']
                 this.tables[objIndex].criteria['fourcri'] = updateData.criteria['four']
                 this.tables[objIndex].criteria['fivecri'] = updateData.criteria['five']
                 this.tables[objIndex].criteria['sixcri'] = updateData.criteria['six']
                 this.tables[objIndex].criteria['sevencri'] = updateData.criteria['seven']
                 this.tables[objIndex].criteria['eightcri'] = updateData.criteria['eight']
                 this.tables[objIndex].criteria['ninecri'] = updateData.criteria['nine']
                 this.tables[objIndex].criteria['tencri'] = updateData.criteria['ten']

                  for(let x= 0 ; x<=this.tables.length ; x++){
                        this.averageScore+=this.tables[x].score
                        
                        if(this.tables[x].score > 0){
                            this.totalWeekScore+=1
                        }


                 }

             }
             


        },

        weekForm(id){
        this.weekno = id.no
        this.month = id.month
        this.$emit('weekForm',id)

      },

   },
}
</script>
<style>
.averageScoreLabel{
    color:rgb(86, 86, 86);
    font-size:9px;
    margin-left: 120px !important;
}
.averageScore{
    color:rgb(0, 143, 58)
}
</style>